import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

// Font families used by the original design (registered under their literal
// names so the ported stylesheets resolve them directly).
import '@fontsource/inter/200.css'
import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/inter/800.css'
import '@fontsource/poppins/300.css'
import '@fontsource/poppins/400.css'
import '@fontsource/poppins/500.css'
import '@fontsource/poppins/600.css'
import '@fontsource/poppins/700.css'
import '@fontsource/poppins/800.css'
import '@fontsource/manrope/400.css'
import '@fontsource/manrope/700.css'
import '@fontsource/manrope/800.css'

// Tailwind / shadcn tokens, then the ported Webflow design system on top.
import '@/styles/globals.css'
import '@/styles/webflow/normalize.css'
import '@/styles/webflow/webflow.css'
import '@/styles/webflow/manila.css'
import '@/styles/webflow/interactions.css'

import AnimationProvider from '@/components/anim/animation-provider'

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <AnimationProvider>
            <Component {...pageProps} />
        </AnimationProvider>
    )
}

export default App
